import axios from '@/backend'
import _ from 'lodash'

const defaultState = () => {
  return {
    id: null,
    mailbox: null,
    message_state: {},
    tags: [],
    message_items: [],
    to_email: [],
    cc: [],
    subject: '',
    status: null,
    user: null,
    attachments: [],
    content: '',
    viewers: [],
    hasTicket: false,
    draftCount: 0
  }
}

const state = {
  message: defaultState(),
  parent: null,
  forwarded_message: false,
  updates: 0,
  error: '',
  loading_status: true
}

function hasTicket (ticket) {
  if (ticket && ticket.id) {
    return true
  } else {
    return false
  }
}

const getters = {
  message (state) {
    return state.message
  },
  messageError (state) {
    return state.error
  },
  loadingStatus (state) {
    return state.loading_status
  },
  messageUpdates (state) {
    return state.updates
  },
  forwardedMessage (state) {
    return state.forwarded_message
  }
}

const mutations = {

  incUpdates (state) {
    _.set(state, 'updates', state.updates + 1)
  },

  setErrors (state, errors) {
    console.log(errors)
    _.set(state, errors, errors)
  },

  resetUpdates (state) {
    _.set(state, 'updates', 0)
  },

  updateMessage (state, params) {
    _.set(state, 'message', params)
  },

  setMessage (state, message) {
    _.set(state, 'message', message)
    _.set(state, 'message.hasTicket', hasTicket(message.ticket))
    _.set(state, 'message.draftCount', message.message_items.filter(item => item.entity_name === 'MessageDraft').length)
  },

  setDefaultMessage (stste) {
    _.set(state.message, defaultState())
  },

  setForwardedMessage (state, forwardedMessage) {
    _.set(state, 'forwarded_message', forwardedMessage)
  },
  setLoadingStatus (state, status) {
    _.set(state, 'loading_status', status)
  }
}

const actions = {
  loadMessage ({dispatch, commit}, {messageId, externalToken}) {
    commit('setLoadingStatus', true)
    return axios.get('/messages/' + messageId, {params: {external_token: externalToken}})
      .then(function (response) {
        commit('setMessage', response.data)
        commit('resetUpdates')
        dispatch('loadMailbox', response.data.mailbox_id)
      })
      .catch(e => { commit('setErrors', e) })
      .finally(() => commit('setLoadingStatus', false))
  },

  reloadMessage ({dispatch, commit}) {
    dispatch('loadMessage', { messageId: state.message.id })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/message.js